import { HttpError } from "@/api/http";
import { referenceKindName } from "@/lib/chart";

/**
 * The code of a refusal: the API's problem type ends in it ("…/problems/account_in_use"), the mock's
 * StoreError carries it. Null for anything else.
 */
export function refusalCode(error: unknown): string | null {
  if (error instanceof HttpError) return error.problem.type.split("/").pop() ?? null;
  if (error && typeof error === "object" && "code" in error) return String(error.code);
  return null;
}

/**
 * What to tell the person. `account_in_use` carries account code → the kinds of thing still using it in
 * `errors`, which HttpError would otherwise join into a list of bare words; this names them.
 */
export function refusalMessage(error: unknown): string | null {
  if (!error) return null;
  if (
    error instanceof HttpError &&
    refusalCode(error) === "account_in_use" &&
    error.problem.errors &&
    Object.keys(error.problem.errors).length > 0
  ) {
    const uses = Object.entries(error.problem.errors)
      .map(([code, kinds]) => `${code} (${kinds.map(referenceKindName).join(", ")})`)
      .join("; ");
    return `These accounts are still in use, so nothing was changed: ${uses}.`;
  }
  return error instanceof Error ? error.message : "That did not work. Try again.";
}
